export const AI_AVATAR = {
  alt: 'KIP AI',
  src: '/kip-avatar.png',
};
